<template>
  <div class="toast">
    <icon :type="type" v-if="type"></icon>
    <span>{{ message }}</span>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
    type: { type: String, default: 'iconic_smile' },
  },
};
</script>

<style lang="scss" >
.toast {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(56, 56, 56, 0.2);
  border: 1px solid #d3d3d3;
  border-radius: 1px;
  padding: 10px 20px;
  max-width: 280px;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  position: fixed;
  top: 40%;
  left: 50%;
  z-index: 99;
  animation: fade-up 0.3s linear both;

  span {
    font-size: 14px;
    color: #222226 !important;
    text-align: left;
    margin-left: 8px;
  }

  .icon {
    width: 18px;
    height: 18px;
  }
}

@keyframes fade-up {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(100%);
  }

  100% {
    opacity: 1;
    transform: translateX(-50%) translateY(0%);
  }
}
</style>
